<template>
  <new-booking />
</template>

<script>
import NewBooking from "@/components/3pl/Operations/Bookings/NewBooking/Index";
export default {
  components: {
    NewBooking,
  },
};
</script>

<style></style>
